import {
	Input,
	InputRadio,
	ItandiChip,
	RiUserLine
} from "@itandi/itandi-bb-ui";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { DealUpdateParam } from "~/models/DealForm";
import Styles from "./Block.module.scss";

export const TenantBlock: React.FC = () => {
	const { register, watch, formState } = useFormContext<DealUpdateParam>();
	const inspectionBy = watch("inspectionBy");
	const { errors } = formState;
	return (
		<div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormRowLabel}>
					<span className={Styles.BlockIconWrapper}>
						<RiUserLine className={Styles.BlockIcon} />
					</span>
					入居者情報
				</div>
			</div>
			{watch("dealType") === "restoration" && (
				<div className={Styles.FormRow}>
					<div className={Styles.FormLabelCol}>
						<span className={Styles.FormLabelText}>立会者</span>
						<span className={Styles.RequiredLabel}>
							<ItandiChip label="必須" />
						</span>
					</div>
					<div className={Styles.FormSettingCol}>
						<div className={Styles.InputRadioGroup}>
							<InputRadio
								label="施工会社"
								value="vendor"
								{...register("inspectionBy")}
							/>
							<InputRadio
								label="管理会社"
								value="company"
								{...register("inspectionBy")}
							/>
							<InputRadio
								label="なし"
								value="none"
								{...register("inspectionBy")}
							/>
						</div>
						<div className={Styles.InvalidFeedback}>
							{errors.inspectionBy?.message}
						</div>
					</div>
				</div>
			)}
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>入居者氏名</span>
					<span className={Styles.RequiredLabel}>
						<ItandiChip label={inspectionBy === "vendor" ? "必須" : "任意"} />
					</span>
				</div>
				<div className={Styles.FormSettingCol}>
					氏名
					<Input isInvalid={!!errors.tenantName} {...register("tenantName")} />
					<div className={Styles.InvalidFeedback}>
						{errors.tenantName?.message}
					</div>
					カナ
					<Input
						isInvalid={!!errors.tenantNameKana}
						{...register("tenantNameKana")}
					/>
					<div className={Styles.InvalidFeedback}>
						{errors.tenantNameKana?.message}
					</div>
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>入居者電話番号</span>
					<span className={Styles.RequiredLabel}>
						<ItandiChip label={inspectionBy === "vendor" ? "必須" : "任意"} />
					</span>
				</div>
				<div className={Styles.FormSettingCol}>
					<Input isInvalid={!!errors.tenantTel} {...register("tenantTel")} />
					<div className={Styles.InvalidFeedback}>
						{errors.tenantTel?.message}
					</div>
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					<span className={Styles.FormLabelText}>入居者メールアドレス</span>
					<span className={Styles.RequiredLabel}>
						<ItandiChip label="任意" />
					</span>
				</div>
				<div className={Styles.FormSettingCol}>
					<Input
						isInvalid={!!errors.tenantEmail}
						{...register("tenantEmail")}
					/>
					<div className={Styles.InvalidFeedback}>
						{errors.tenantEmail?.message}
					</div>
				</div>
			</div>
		</div>
	);
};
